export const education = [
    {
        id: 1,
        uniName: 'Francisk Skorina Gomel Sate University',
        uniLogo: '/images/uni/GSU.jpg',
        faculty: 'Physics and Information Technologies', 
        department: 'Automated Information Processing Systems',
        grade: "Bachelor's degree with honors as a software engineer",
        startDate: 'September 1, 2015',
        endDate: 'June 1, 2019'
    }
];